import {createUser, login, logout, retrieveUser} from "../clients/UserClient";
import React, {useEffect, useState} from "react";
import {retrieveHistory} from "../clients/HistoryClient";
import {Table} from "../components/Table";
import ClientComponent from "../components/ClientComponent";
import {useNavigate} from "react-router-dom";
import Profile from "../components/Profile";
import ModalHeader from "../components/ModalHeader";

export const FormField = ({name, title, value, onChange, type = "text"}) => {
    return (<div>
        <p style={{marginTop: '20px', marginBottom: "0rem", color: "#666"}}>{title}</p>
        <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            style={{borderRadius: "0.2rem", border: "1px solid #aaa", color: "#666", fontSize: "0.75rem"}}
        />
    </div>)
}

const SignupModal = ({onEscape}) => {
    const [username, setUsername] = useState(null)
    const [email, setEmail] = useState(null)
    const [password, setPassword] = useState(null)
    const [repeatedPassword, setRepeatedPassword] = useState(null)
    const navigate = useNavigate();

    const emailRegex = /^[a-zA-Z0-9._%+1]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    const validateEmail = (email) => {
        return emailRegex.test(email)
    }

    const handleKeyDown = (event) => {
        if (event.key === "Escape") {
            onEscape();
        }
    }

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)

        return () => window.removeEventListener("keydown", handleKeyDown)
    }, []);

    const validateAndCreateUser = async () => {
        if (!validateEmail(email)) {
            throw new Error("Missing or invalid characters in e-mail")
        } else if (!isPasswordSet() || !doPasswordsMatch(repeatedPassword)) {
            throw new Error("Passwords must match")
        }

        if(!username || username.trim().length === 0 || username.trim().length > 25) {
            throw new Error("Invalid username length. Username must be between 1 to 25 characters")
        }

        return await createUser(username, email, password)
    }

    const isPasswordSet = () => {
        return password && password.trim().length > 0
    }

    const doPasswordsMatch = (repeatPassword) => {
        return password === repeatPassword
    }

    const setRepeatPassword = async (repeatPassword) => {
        setRepeatedPassword(repeatPassword)
    }

    return (
        <div className="modal-overlay" onClick={onEscape}>
            <div className="modal-content"
                 style={{overflow: "hidden", display: "flex", flexDirection: "column", alignItems: "center"}}
                 onClick={(e) => e.stopPropagation()}>
                <ModalHeader/>
                <FormField name="username" title="Username" value={username}
                           onChange={(e) => setUsername(e.target.value)}/>
                <FormField name="email" title="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                <FormField name="password" title="Password" value={password} type="password"
                           onChange={(e) => setPassword(e.target.value)}/>
                <FormField name="repeatPassword" title="Repeat Password" value={repeatedPassword} type="password"
                           onChange={(e) => setRepeatPassword(e.target.value)}/>
                <ClientComponent sendData={async () => {await validateAndCreateUser(); await login(username, password)}}
                                 callback={() => navigate(0)} buttonTitle="Create User" showSuccessMessage={false}/>
            </div>
        </div>
    )
}

const LoginModal = ({onEscape}) => {
    const [username, setUsername] = useState(null)
    const [password, setPassword] = useState(null)
    const navigate = useNavigate();

    const handleKeyDown = (event) => {
        if (event.key === "Escape") {
            onEscape();
        }
    }

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)

        return () => window.removeEventListener("keydown", handleKeyDown)
    }, []);

    return (<div className="modal-overlay" onClick={onEscape}>
        <div className="modal-content"
             style={{overflow: "hidden", display: "flex", flexDirection: "column", alignItems: "center"}}
             onClick={(e) => e.stopPropagation()}>
            <ModalHeader/>
            <FormField name="username" title="Username" value={username} onChange={(e) => setUsername(e.target.value)}/>
            <FormField name="password" title="Password" value={password} type="password" onChange={(e) => setPassword(e.target.value)}/>
            <ClientComponent sendData={() => login(username, password)} buttonTitle="Login"
                             callback={() => navigate(0)}
                             showSuccessMessage={false}/>
        </div>
    </div>)

}

const MyProfile = () => {
    const [userData, setUserData] = useState({fetchSuccessful: false})

    const [showLoginForm, setShowLoginForm] = useState(null)
    const [showSignupForm, setShowSignupForm] = useState(null)

    const [loginSuccessful, setLoginSuccessful] = useState(false)

    const toggleSignupForm = () => {
        setShowSignupForm(!showSignupForm)
    }

    const toggleLoginForm = () => {
        setShowLoginForm(!showLoginForm)
    }

    useEffect(() => {
        retrieveUser()
            .then((data) => setUserData({fetchSuccessful: true, ...data}))
            .catch((error) => {
                console.error(error);
                setUserData({fetchSuccessful: false})
            })
    }, [loginSuccessful]);

    return (
        userData.fetchSuccessful ?
            <Profile username={userData.username} ownProfile={true}/> :
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "2rem",
                height: "90vh"
            }}>
                <img
                    src="/logo.png"
                    alt="Site Logo"
                    style={{height: "50%"}}
                />
                <button style={{marginTop: '1rem'}} onClick={toggleSignupForm}>Create User</button>
                <button style={{marginTop: '1rem'}} onClick={toggleLoginForm}>Login</button>
                <div>
                    {showSignupForm && <SignupModal onEscape={() => setShowSignupForm(false)}/>}
                    {showLoginForm && <LoginModal onEscape={() => setShowLoginForm(false)}/>}
                </div>
            </div>
    )
}

export default MyProfile;